import { defineWebModule } from "@signet/web-kit";
import { ChaturbateIcon } from "./logo.tsx";
import { CbStatsPage } from "./page.tsx";
import { CreatorSetupPage } from "./setup.tsx";
import "./cbstats.css";

/* The web half of CB Stats: Reporting (the week) and Creator Setup (usernames, targets, scheduled days). */

const day = (value: unknown) => (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : undefined);

export default defineWebModule({
  id: "cbstats",
  // Either opens CB Stats: someone who only sets creators up lands on Creator Setup.
  nav: { label: "CB Stats", icon: ChaturbateIcon, to: "/cbstats", needs: ["cbstats.stats:view", "cbstats.account:view"] },
  routes: [
    { path: "/cbstats", component: CbStatsPage, needs: "cbstats.stats:view", validateSearch: (raw) => ({ week: day(raw.week) }) },
    { path: "/cbstats/setup", component: CreatorSetupPage, needs: "cbstats.account:view" },
  ],
  commands: [
    { id: "cbstats.week", label: "CB Stats", to: "/cbstats", needs: "cbstats.stats:view", hint: "Chaturbate streams this week", keywords: "chaturbate cb stats streams hours cam target slacking reporting" },
    { id: "cbstats.setup", label: "CB Creator Setup", to: "/cbstats/setup", needs: "cbstats.account:view", hint: "CB Stats", keywords: "chaturbate cb usernames targets schedule hours streams setup" },
  ],
});
